import { useDsnz } from './_csDsn';
import { useLggz } from './_csLgg';
import { useSclz } from './_csScl';
import { useClrz } from './_csClr';
//import { useUserz } from './_csUser';
//import { rfrUserz } from './x_csUser';
import { frcUdt } from './_csLcl';

export const useCmnz = (
) => {

  const _sDsnz = useDsnz();
  const _sLggz = useLggz();
  const _sSclz = useSclz();
  const _sClrz = useClrz();
  //const _gUserz = rfrUserz();
  const _frcUdt = frcUdt();

  return {

    c: _sClrz.c,
    setClr: _sClrz.set,
    crtClr: _sClrz.crt,

    h: _sDsnz.h,
    w: _sDsnz.w,

    t: _sLggz.t,
    setLgg: _sLggz.set,
    crtLgg: _sLggz.crt,

    s: _sSclz.s,
    setScl: _sSclz.set,
    crtScl: _sSclz.crt,

//    setUser: _gUserz.set,
//    crtUser: _gUserz.crt,

    frcUdt: _frcUdt,

  };

};
